import React, { useState } from "react";
import "./ImportJsonPopup.css";

// Accepts the exact JSON shape used by assets/levels/level_0X.json in the
// game repo: { id, name, rows, cols, dropRate, grid }.
const ImportJsonPopup = ({ onImport, onClose }) => {
  const [text, setText] = useState("");
  const [error, setError] = useState("");

  const handleImport = () => {
    try {
      const parsed = JSON.parse(text);
      if (!Array.isArray(parsed.grid) || !parsed.id || !parsed.name) {
        setError("JSON must have id, name, rows, cols, dropRate, grid.");
        return;
      }
      onImport(parsed);
    } catch (e) {
      setError("Invalid JSON: " + e.message);
    }
  };

  return (
    <div className="import-popup-backdrop" onClick={onClose}>
      <div className="import-popup card" onClick={(e) => e.stopPropagation()}>
        <h3>Import level JSON</h3>
        <p style={{ color: "var(--text-secondary)", fontSize: "0.85rem" }}>
          Paste the content of one of the game's assets/levels/level_0X.json files.
        </p>
        <textarea
          rows={12}
          value={text}
          onChange={(e) => setText(e.target.value)}
          placeholder='{"id": 6, "name": "...", "rows": 12, "cols": 9, "dropRate": 0.18, "grid": [...]}'
        />
        {error && <p style={{ color: "var(--danger-color)" }}>{error}</p>}
        <div className="form-actions">
          <button className="btn btn-primary" onClick={handleImport}>
            Import
          </button>
          <button className="btn" onClick={onClose}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default ImportJsonPopup;
